import { Check } from "@mui/icons-material";
import React from "react";

export default function InlineResponse({ responseBreakdown, responseSuccess }) {
  return !responseSuccess && responseBreakdown ? (
    <p className="text-[10px] text-red-600">{responseBreakdown}</p>
  ) : (
    <p className="text-[12px]">
      {responseBreakdown} {responseSuccess ? <Check className="text-green-600" /> : ""}
    </p>
  );
}
